import * as React from 'react';

/* tslint:disable:max-line-length */

interface IProps {
  name: string;
  color?: string;
  style?: any;
}

const setColor = (color) => {
  let setColor;
  switch (color) {
    case 'blue':
      setColor = '#41a5f5'
      break;
    case 'darkBlue':
    case 'admiral':
      setColor = '#0045A0'
      break;
    case 'green':
      setColor = '#00A32E'
      break;
    case 'warning':
      setColor = '#CC0033'
      break;
    case 'white':
      setColor = '#FFFFFF'
      break;
    case 'gold':
      setColor = '#fcb800'
      break;
    case 'platinum':
      setColor = '#a8c2d4'
      break;
    case 'grey':
      setColor = '#ced9e5'
      break;
    default:
      setColor = '#000000'
      break;
  }

  return setColor;
}

export const Admin = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" fill={setColor(color)} height="32"
         viewBox="0 0 32 32">
      <path
        d="M28 10.667v-1.333l-4 2.667-4-2.667v1.333l4 2.667 4-2.667zM29.333 4h-26.667c-1.467 0-2.667 1.2-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667h26.667c1.467 0 2.653-1.2 2.653-2.667l0.013-18.667c0-1.467-1.2-2.667-2.667-2.667zM10.667 8c2.213 0 4 1.787 4 4s-1.787 4-4 4c-2.213 0-4-1.787-4-4s1.787-4 4-4zM18.667 24h-16v-1.333c0-2.667 5.333-4.133 8-4.133s8 1.467 8 4.133v1.333zM29.333 16h-10.667v-8h10.667v8z"/>
    </svg>
  )
}

export const PlaneTickets = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/1999/xlink" width="40" fill={setColor(color)}
         height="40" viewBox="0 0 40 40">
      <path
        d="M7.81 18.39a1 1 0 0 1 1.31-.54l2.23.91 2.38-1-2.58-1.52a1 1 0 1 1 1-1.72L16 16.8l2.31-1a1 1 0 1 1 .77 1.84l-2.31 1-.09.36h4.6a1 1 0 0 1-.13-1l.85-1.83a1 1 0 1 1 1.85.76L23 18.78a.78.78 0 0 1-.12.22h16.55L10.51 7.16a1 1 0 0 0-1.3.55L4.58 19h3.19a1 1 0 0 1 .04-.61zM45 21H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h42a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1zm-30 6.46-1.77 1.77.64 4.46a1 1 0 0 1-.87 1.13h-.14a1 1 0 0 1-1-.86l-.43-3-1.84 1.87v2.41a1 1 0 0 1-2 0v-1.83H5.76a1 1 0 1 1 0-2h2.41L10 29.59l-3-.43a1 1 0 1 1 .28-2l4.46.64 1.77-1.77A1 1 0 0 1 15 27.46zM19 37a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0zm0-5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0zm0-5a1 1 0 0 1-2 0v-2a1 1 0 0 1 2 0zm18 9H23a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2zm-15-5a1 1 0 0 1 1-1h12a1 1 0 0 1 0 2H23a1 1 0 0 1-1-1zm18-3H23a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2z"
        opacity="1" data-original="#000000"/>
    </svg>
  )
}

export const Insurance = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="32" fill={setColor(color)}
         height="32" viewBox="0 0 512 512">
      <g>
        <path
          d="M186 150h90v30h-90zM37.195 357.471C24.85 345.126 7.227 343.933 0 344.013v50.652h50.656c.081-7.155-1.09-24.824-13.461-37.194zM37.194 97.195C49.54 84.85 50.732 67.227 50.652 60H0v50.655c7.156.081 24.824-1.09 37.194-13.46z"
          opacity="1" data-original="#000000"/>
        <path
          d="m247.33 271.435 147.335-48.824L462 244.925v-104.28c-.192.001-.369.005-.567.005-12.489 0-38.246-2.648-57.841-22.242C383.689 98.506 381.273 72.257 381.354 60H321V0H141v60H80.646c.081 12.257-2.335 38.506-22.238 58.408C38.816 138 13.058 140.649.567 140.65c-.198 0-.376-.004-.567-.005v173.374c12.256-.081 38.505 2.335 58.408 22.238 19.902 19.902 22.318 46.151 22.237 58.408h167.12a161.642 161.642 0 0 1-.436-11.771V271.435zM171 30h120v30H171zm-67.21 243.214 77.606-32.146 11.48 27.717-77.606 32.146zM306 210H156v-90h150zM424.805 97.195c12.347 12.346 29.97 13.538 37.195 13.457V60h-50.656c-.081 7.156 1.091 24.824 13.461 37.195zM437 382.894v-35.638l-42.335-14.029-42.335 14.029v35.638a54.127 54.127 0 0 0 42.335 52.911A54.128 54.128 0 0 0 437 382.894z"
          opacity="1" data-original="#000000"/>
        <path
          d="M394.665 254.215 277.33 293.098v89.795c0 62.952 45.011 116.493 107.026 127.309L394.665 512l10.309-1.798C466.989 499.386 512 445.845 512 382.894v-89.795zM467 382.894a84.08 84.08 0 0 1-69.758 82.978l-2.577.45-2.577-.45a84.08 84.08 0 0 1-69.758-82.978v-57.301l72.335-23.971L467 325.592z"
          opacity="1" data-original="#000000"/>
      </g>
    </svg>
  )
}

export const Person = (color) => {

  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="24" height="24"
         viewBox="0 0 32 32">
      <path
        d="M16 16c2.947 0 5.333-2.387 5.333-5.333s-2.387-5.333-5.333-5.333c-2.947 0-5.333 2.387-5.333 5.333s2.387 5.333 5.333 5.333zM16 18.667c-3.56 0-10.667 1.787-10.667 5.333v2.667h21.333v-2.667c0-3.547-7.107-5.333-10.667-5.333z"/>
    </svg>
  )
}

export const People = (color) => {

  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32">
      <path
        d="M22.227 17.507c1.827 1.24 3.107 2.92 3.107 5.16v4h5.333v-4c0-2.907-4.76-4.627-8.44-5.16zM12 16c2.945 0 5.333-2.388 5.333-5.333s-2.388-5.333-5.333-5.333c-2.946 0-5.333 2.388-5.333 5.333s2.388 5.333 5.333 5.333zM20 16c2.947 0 5.333-2.387 5.333-5.333s-2.387-5.333-5.333-5.333c-0.627 0-1.213 0.133-1.773 0.32 1.107 1.373 1.773 3.12 1.773 5.013s-0.667 3.64-1.773 5.013c0.56 0.187 1.147 0.32 1.773 0.32zM12 17.333c-3.56 0-10.667 1.787-10.667 5.333v4h21.333v-4c0-3.547-7.107-5.333-10.667-5.333z"/>
    </svg>
  )
}

export const Edit = (color) => {

  return (
    <svg version="1.1" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg" width="14" height="14"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M4 23v5h5l14.747-14.747-5-5-14.747 14.747zM27.613 9.387c0.52-0.52 0.52-1.36 0-1.88l-3.12-3.12c-0.52-0.52-1.36-0.52-1.88 0l-2.44 2.44 5 5 2.44-2.44z"/>
    </svg>

  )
}

export const Editing = (color) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512" className="adm-icon__svg"
         fill={setColor(color)}>
      <path
        d="M292.545 325.52a45.258 45.258 0 0 1-17.589 10.871l-63.641 21.213a44.9 44.9 0 0 1-14.229 2.31h-.001c-12.021 0-23.321-4.681-31.82-13.181-12.131-12.134-16.295-29.778-10.87-46.051l21.214-63.638a45.208 45.208 0 0 1 10.87-17.59L323.934 82H55c-30.327 0-55 24.673-55 55v320c0 30.327 24.673 55 55 55h320c30.327 0 55-24.673 55-55V188.066z"/>
      <path
        d="M207.693 240.668a14.993 14.993 0 0 0-3.623 5.863l-21.214 63.639a15 15 0 0 0 18.973 18.973l63.64-21.213a14.986 14.986 0 0 0 5.863-3.623l187.384-187.383-63.639-63.639zM476.393 7.322c-9.763-9.763-25.592-9.763-35.355 0l-24.749 24.749 63.64 63.64 24.749-24.749c9.763-9.763 9.763-25.592 0-35.355z"/>
    </svg>

  )
}

export const Destination = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 511.272 511.272" fill={setColor(color)}>
      <g>
        <path
          d="M135.104 54.102c0 3.987-.305 7.956-.891 11.878 39.179-22.847 80.691-34.82 121.424-34.82 59.96 0 116.331 23.35 158.729 65.747 42.399 42.399 65.748 98.77 65.748 158.73 0 31.568-2.811 52.04-11.43 74.561a79.217 79.217 0 0 1 29.36 10.392c9.764-25.863 13.228-50.079 13.228-84.954 0-68.283-26.591-132.478-74.874-180.762C388.115 26.592 323.919.001 255.637.001c-41.618 0-83.715 10.864-123.731 31.683a80.289 80.289 0 0 1 3.198 22.418zM415.178 433.448c.65 1.078.042.078 1.58 2.544l37.546 60.451c2.299 3.701 7.724 3.583 9.86-.214l35.352-62.859h-.034c4.417-7.678 6.812-16.667 6.418-26.249-1.036-25.179-21.6-45.645-46.784-46.555-27.679-1.001-50.433 21.141-50.433 48.597a48.377 48.377 0 0 0 6.506 24.286h-.011zm42.135-39.43c8.359 0 15.135 6.776 15.135 15.135s-6.776 15.135-15.135 15.135-15.135-6.776-15.135-15.135 6.777-15.135 15.135-15.135zM97.421 78.679h-.035c4.485-7.795 6.916-16.921 6.516-26.65-1.051-25.565-21.93-46.343-47.5-47.267C28.301 3.746 5.199 26.226 5.199 54.102c0 8.984 2.412 17.4 6.605 24.658h-.011c.66 1.095.042.079 1.604 2.583l38.199 61.501c2.299 3.701 7.724 3.583 9.86-.214zM39.206 54.093c0-8.486 6.88-15.366 15.366-15.366 8.487 0 15.366 6.88 15.366 15.366 0 8.487-6.88 15.366-15.366 15.366s-15.366-6.88-15.366-15.366zM390.298 452.445a314.3 314.3 0 0 0-.959-1.531c-.294-.467-.295-.466-.686-1.116l-.155-.257a30.66 30.66 0 0 1-.775-1.361 79.367 79.367 0 0 1-4.305-8.946c-38.105 27.783-79.316 40.878-127.781 40.878-59.96 0-116.332-23.35-158.73-65.747-42.399-42.399-65.748-98.77-65.748-158.73 0-31.798 3.183-55.661 10.946-77.054a31.126 31.126 0 0 1-11.865-11.07l-10.241-16.488C3.767 184.883 0 218.043 0 255.636c0 68.283 26.591 132.478 74.875 180.762s112.479 74.874 180.762 74.874c54.34 0 100.637-14.362 143.365-44.814z"
        />
        <path
          d="M127.951 219.735c6.425 1.498 14.233 1.281 23.871-.663 7.472-1.507 13.59-4.783 17.226-9.225 1.897-2.318 3.632-5.552 5.468-8.976 2.725-5.082 5.814-10.842 10.638-16.073 8.67-9.402 19.685-13.742 29.404-17.571 3.046-1.201 5.923-2.335 8.565-3.556 24.31-11.243 42.348-42.519 40.209-69.721a15.606 15.606 0 0 1 .039-2.738 166.738 166.738 0 0 0-7.734-.186c-78.877 0-144.78 55.498-160.823 129.572 10.774-2.257 22.572-3.322 33.137-.863zM417.015 283.868c-14.358-2.473-39.391-2.923-53.761-1.789-49.163 3.874-71.285-1.685-87.867-8.267-2.391-.949-4.731-1.96-6.992-2.937-7.793-3.366-15.149-6.542-20.299-5.32-4.207 1.004-8.361 5.813-10.335 11.965-2.411 7.512-2.193 16.519-1.693 26.663l.17 3.399c.837 16.524 1.702 33.61-1.821 50.968-3.665 18.061-19.715 39.137-35.243 51.66 17.61 6.432 36.625 9.943 56.461 9.943 81.212 0 148.676-58.829 162.12-136.196-.246-.031-.492-.047-.74-.089z"
        />

        <path
          d="M174.555 389.557c12.043-7.197 27.119-26.321 29.327-37.205 2.741-13.508 2.011-27.929 1.238-43.197l-.172-3.438c-.63-12.752-.863-25.234 3.145-37.721 5.345-16.652 17.902-29.201 32.769-32.749 15.224-3.637 28.901 2.276 39.889 7.023 2.147.928 4.174 1.803 6.132 2.581 23.25 9.229 50.349 8.023 73.923 6.164 15.53-1.222 42.041-.85 59.357 1.801-1.26-76.228-54.342-139.838-125.55-157.135 1.221 39.209-23.307 80.033-58.414 96.269-3.459 1.601-6.896 2.955-10.222 4.265-7.245 2.855-14.089 5.551-17.919 9.705-2.142 2.323-4.057 5.894-6.085 9.675-2.345 4.374-5.002 9.329-8.818 13.99-8.18 9.992-20.672 17.105-35.175 20.031-14.1 2.845-26.235 2.997-37.101.466-8-1.862-19.995.739-29.785 3.638-.007.624-.024 1.245-.024 1.87 0 59.051 31.109 110.827 77.825 139.861a15.508 15.508 0 0 1 5.66-5.894z"
        />
      </g>
    </svg>
  )
}

export const Globe = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 11.39 4.08 10.79 4.21 10.22L8.99 15V16C8.99 17.1 9.89 18 10.99 18V19.93C7.06 19.43 4 16.07 4 12ZM17.89 17.4C17.63 16.59 16.89 16 15.99 16H14.99V13C14.99 12.45 14.54 12 13.99 12H7.99V10H9.99C10.54 10 10.99 9.55 10.99 9V7H12.99C14.09 7 14.99 6.1 14.99 5V4.59C17.92 5.77 20 8.65 20 12C20 14.08 19.19 15.98 17.89 17.4Z"/>
    </svg>
  )
}

export const ShieldTicked = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" fill={setColor(color)} height="24"
         viewBox="0 0 32 32">
      <path
        d="M16 1.333l-12 5.333v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8l-12-5.333zM13.333 22.667l-5.333-5.333 1.88-1.88 3.453 3.44 8.787-8.787 1.88 1.893-10.667 10.667z"/>
    </svg>
  )
}

export const Tick = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill={setColor(color)}
         viewBox="0 0 32 32" className="adm-icon__svg">
      <title>included</title>
      <path d="M12 21.6l-5.6-5.6-1.867 1.867 7.467 7.467 16-16-1.867-1.867-14.133 14.133z"/>
    </svg>

  )
}

export const ShieldPlus = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M4 6.667v8c0 7.4 5.12 14.32 12 16 6.88-1.68 12-8.6 12-16v-8l-12-5.333-12 5.333zM22.667 17.333h-5.333v5.333h-2.667v-5.333h-5.333v-2.667h5.333v-5.333h2.667v5.333h5.333v2.667z"/>
    </svg>

  )
}

export const WinterSports = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg"
         className="adm-icon__svg">
      <path
        d="M18.5 4.5C18.5 5.6 17.6 6.5 16.5 6.5C15.4 6.5 14.5 5.6 14.5 4.5C14.5 3.4 15.4 2.5 16.5 2.5C17.6 2.5 18.5 3.4 18.5 4.5ZM15.78 20.9L16.54 21.17C17.16 21.38 17.81 21.5 18.5 21.5C19.34 21.5 20.15 21.32 20.88 21L22 22.13C20.95 22.68 19.76 23 18.5 23C17.64 23 16.82 22.86 16.05 22.59L2 17.47L2.5 16.06L9.4 18.57L11.12 14.13L7.55 10.4C6.66 9.46 6.88 7.93 8 7.28L11.48 5.27C12.58 4.63 14 5.17 14.39 6.38L14.72 7.46C15.16 8.88 16.2 10.03 17.55 10.6L18.07 9L19.5 9.46L18.38 12.91C15.93 12.51 13.9 10.84 13 8.59L10.47 10.04L13.5 13.5L11.28 19.26L14.37 20.38L16.47 13.94C16.93 14.12 17.41 14.25 17.91 14.35L15.78 20.9Z"/>
    </svg>
  )
}

export const Excess = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg"
         className="adm-icon__svg">
      <path
        d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z"/>
    </svg>

  )
}

export const GolfCover = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg"
         className="adm-icon__svg">
      <path
        d="M9 2L17 5.92L11 8.98V18.03C13.84 18.19 16 19.01 16 20C16 21.1 13.31 22 10 22C6.69 22 4 21.1 4 20C4 19.26 5.21 18.62 7 18.27V20H9V2Z"
        fill={setColor(color)}/>
      <path
        d="M21 19.5C21 20.3284 20.3284 21 19.5 21C18.6716 21 18 20.3284 18 19.5C18 18.6716 18.6716 18 19.5 18C20.3284 18 21 18.6716 21 19.5Z"
        fill={setColor(color)}/>
    </svg>
  )
}

export const GadgetCover = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="24" height="24"
         viewBox="0 0 24 32" className="adm-icon__svg">
      <path
        d="M20.667 1.333h-10.667c-1.84 0-3.333 1.493-3.333 3.333v22.667c0 1.84 1.493 3.333 3.333 3.333h10.667c1.84 0 3.333-1.493 3.333-3.333v-22.667c0-1.84-1.493-3.333-3.333-3.333zM15.333 29.333c-1.107 0-2-0.893-2-2s0.893-2 2-2c1.107 0 2 0.893 2 2s-0.893 2-2 2zM21.333 24h-12v-18.667h12v18.667z"/>
    </svg>
  )
}

export const CruiseCover = (color) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg"
         className="adm-icon__svg">
      <path
        d="M20 21C18.61 21 17.22 20.53 16 19.68C13.56 21.39 10.44 21.39 8.00001 19.68C6.78001 20.53 5.39001 21 4.00001 21H2.00001V23H4.00001C5.38001 23 6.74001 22.65 8.00001 22.01C10.52 23.3 13.48 23.3 16 22.01C17.26 22.66 18.62 23 20 23H22V21H20ZM3.95001 19H4.00001C5.60001 19 7.02001 18.12 8.00001 17C8.98001 18.12 10.4 19 12 19C13.6 19 15.02 18.12 16 17C16.98 18.12 18.4 19 20 19H20.05L21.94 12.32C22.02 12.06 22 11.78 21.88 11.54C21.76 11.3 21.54 11.12 21.28 11.04L20 10.62V6C20 4.9 19.1 4 18 4H15V1H9.00001V4H6.00001C4.90001 4 4.00001 4.9 4.00001 6V10.62L2.71001 11.04C2.45001 11.12 2.23001 11.3 2.11001 11.54C1.99001 11.78 1.96001 12.06 2.05001 12.32L3.95001 19ZM6.00001 6H18V9.97L12 8L6.00001 9.97V6Z"/>
    </svg>
  )
}

export const Calendar = (color) => {
  return (
    <svg version="1.1" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg" width="32" height="32"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M26.667 4h-1.333v-2.667h-2.667v2.667h-13.333v-2.667h-2.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v21.333c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-21.333c0-1.467-1.2-2.667-2.667-2.667zM26.667 28h-21.333v-17.333h21.333v17.333z"/>
    </svg>

  )
}

export const IPID = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M8 2.667c-1.467 0-2.653 1.2-2.653 2.667l-0.013 21.333c0 1.467 1.187 2.667 2.653 2.667h16.013c1.467 0 2.667-1.2 2.667-2.667v-16l-8-8h-10.667zM17.333 12v-7.333l7.333 7.333h-7.333z"/>
    </svg>
  )
}

export const IMPORTANTSTATEMENT = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32">
      <path
        d="M18.667 2.667h-10.667c-1.467 0-2.653 1.2-2.653 2.667l-0.013 21.333c0 1.467 1.187 2.667 2.653 2.667h16.013c1.467 0 2.667-1.2 2.667-2.667v-16l-8-8zM8 26.667v-21.333h9.333v6.667h6.667v14.667h-16z"/>
    </svg>
  )
}

export const DATE = (color) => {
  return (
    <svg version="1.1" fill={setColor(color)} xmlns="http://www.w3.org/2000/svg" width="32" height="32"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M26.667 4h-1.333v-2.667h-2.667v2.667h-13.333v-2.667h-2.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v21.333c0 1.467 1.2 2.667 2.667 2.667h21.333c1.467 0 2.667-1.2 2.667-2.667v-21.333c0-1.467-1.2-2.667-2.667-2.667zM26.667 28h-21.333v-17.333h21.333v17.333z"/>
    </svg>
  )
}

export const MONEY = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M6.667 5.333h24v16h-24v-16zM18.667 9.333c1.061 0 2.078 0.421 2.828 1.172s1.172 1.768 1.172 2.828c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172c-1.061 0-2.078-0.421-2.828-1.172s-1.172-1.768-1.172-2.828c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172zM12 8c0 0.707-0.281 1.386-0.781 1.886s-1.178 0.781-1.886 0.781v5.333c0.707 0 1.386 0.281 1.886 0.781s0.781 1.178 0.781 1.886h13.333c0-0.707 0.281-1.385 0.781-1.886s1.178-0.781 1.886-0.781v-5.333c-0.707 0-1.385-0.281-1.886-0.781s-0.781-1.178-0.781-1.886h-13.333zM1.333 10.667h2.667v13.333h21.333v2.667h-24v-16z"/>
    </svg>


  )
}

export const WARNING = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="20" height="20"
         viewBox="0 0 32 32" className="adm-icon__svg">
      <path
        d="M1.333 28h29.333l-14.667-25.333-14.667 25.333zM17.333 24h-2.667v-2.667h2.667v2.667zM17.333 18.667h-2.667v-5.333h2.667v5.333z"/>
    </svg>
  )
}

export const PAYMENT = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32">
      <path
        d="M26.667 5.333h-21.333c-1.48 0-2.653 1.187-2.653 2.667l-0.013 16c0 1.48 1.187 2.667 2.667 2.667h21.333c1.48 0 2.667-1.187 2.667-2.667v-16c0-1.48-1.187-2.667-2.667-2.667zM26.667 24h-21.333v-8h21.333v8zM26.667 10.667h-21.333v-2.667h21.333v2.667z"/>
    </svg>
  )
}

export const LOCK = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} width="32" height="32"
         viewBox="0 0 32 32">
      <path
        d="M24 10.667h-1.333v-2.667c0-3.68-2.987-6.667-6.667-6.667s-6.667 2.987-6.667 6.667v2.667h-1.333c-1.467 0-2.667 1.2-2.667 2.667v13.333c0 1.467 1.2 2.667 2.667 2.667h16c1.467 0 2.667-1.2 2.667-2.667v-13.333c0-1.467-1.2-2.667-2.667-2.667zM16 22.667c-1.467 0-2.667-1.2-2.667-2.667s1.2-2.667 2.667-2.667c1.467 0 2.667 1.2 2.667 2.667s-1.2 2.667-2.667 2.667zM20.133 10.667h-8.267v-2.667c0-2.28 1.853-4.133 4.133-4.133s4.133 1.853 4.133 4.133v2.667z"/>
    </svg>
  )
}
export const SUMMARY = (color) => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" fill={setColor(color)} height="32"
         viewBox="0 0 32 32">
      <path
        d="M4 17.333h2.667v-2.667h-2.667v2.667zM4 22.667h2.667v-2.667h-2.667v2.667zM4 12h2.667v-2.667h-2.667v2.667zM9.333 17.333h18.667v-2.667h-18.667v2.667zM9.333 22.667h18.667v-2.667h-18.667v2.667zM9.333 9.333v2.667h18.667v-2.667h-18.667z"/>
    </svg>
  )
}

export const AnnualCalendar = (color, style) => {
  return (
    <svg height="32" viewBox="0 0 512 512" width="32" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)}
         style={style}>
      <g>
        <path
          d="m451.75 64v-18.88c0-24.88-20.24-45.12-45.13-45.12-24.88 0-45.12 20.24-45.12 45.12v18.88h30v-18.88c0-8.33 6.79-15.12 15.12-15.12 8.34 0 15.13 6.79 15.13 15.12v18.88h-30.25v31.38h-30v-31.38h-60.38v-18.88c0-24.88-20.24-45.12-45.12-45.12s-45.12 20.24-45.12 45.12v18.88h30v-18.88c0-8.33 6.78-15.12 15.12-15.12s15.12 6.79 15.12 15.12v18.88h-30.24v31.38h-30v-31.38h-60.38v-18.88c0-24.88-20.24-45.12-45.12-45.12-24.89 0-45.13 20.24-45.13 45.12v18.88h30v-18.88c0-8.33 6.79-15.12 15.13-15.12 8.33 0 15.12 6.79 15.12 15.12v18.88h-30.25v31.38h-30v-31.38h-60.25v63h512v-63z"/>
        <path
          d="m0 191 42.4 17.59 53.4-22.16 53.4 22.16 53.4-22.16 53.39 22.16 53.4-22.16 53.4 22.16 53.4-22.16 53.4 22.16 42.41-17.59v-34h-512z"/>
        <path
          d="m416.19 218.91-53.4 22.16-53.4-22.16-53.4 22.16-53.39-22.16-53.4 22.16-53.4-22.16-53.4 22.16-42.4-17.59v288.52h512v-288.52l-42.41 17.59zm-235.565 182.59c0 24.882-20.243 45.125-45.125 45.125s-45.125-20.243-45.125-45.125h30c0 8.34 6.785 15.125 15.125 15.125s15.125-6.785 15.125-15.125-6.785-15.125-15.125-15.125h-15v-30h15.01c8.335-.005 15.115-6.788 15.115-15.125 0-8.34-6.785-15.125-15.125-15.125s-15.125 6.785-15.125 15.125h-30c0-24.882 20.243-45.125 45.125-45.125s45.125 20.243 45.125 45.125c0 11.568-4.38 22.13-11.563 30.125 7.183 7.995 11.563 18.557 11.563 30.125zm75.375-45.125c24.882 0 45.125 20.243 45.125 45.125s-20.243 45.125-45.125 45.125-45.125-20.243-45.125-45.125v-60.25c0-24.882 20.243-45.125 45.125-45.125s45.125 20.243 45.125 45.125h-30c0-8.34-6.785-15.125-15.125-15.125s-15.125 6.785-15.125 15.125v17.741c4.731-1.688 9.821-2.616 15.125-2.616zm165.625-15.125h-30v-15.125h-30.25v30.25h15.125c24.882 0 45.125 20.243 45.125 45.125s-20.243 45.125-45.125 45.125-45.125-20.243-45.125-45.125h30c0 8.34 6.785 15.125 15.125 15.125s15.125-6.785 15.125-15.125-6.785-15.125-15.125-15.125h-45.125v-90.25h90.25z"/>
        <circle cx="256" cy="401.5" r="15.125"/>
      </g>
    </svg>
  )
}

export const Luggage = (color, style) => {
  return (
    <svg height="32" viewBox="0 0 512 512" width="32" xmlns="http://www.w3.org/2000/svg" fill={setColor(color)} style={style}>
      <path
        d="m322 39.001c0-4.962 4.038-9 9-9h52c4.963 0 9 4.038 9 9v53.615h30v-53.615c0-21.505-17.495-39-39-39h-52c-21.505 0-39 17.495-39 39v53.615h30z"/>
      <path
        d="m182.338 482.002c-6.554-10.184-10.338-22.24-10.338-35v-224.885h-137c-19.299 0-35 15.701-35 35v189.885c0 17.601 13.061 32.203 30 34.637v15.359c0 8.284 6.716 15 15 15s15-6.716 15-15v-14.997h122.338zm-122.338-204.885c0-8.284 6.716-15 15-15s15 6.716 15 15v149.885c0 8.284-6.716 15-15 15s-15-6.716-15-15z"/>
      <path
        d="m140 168.501c0-4.962 4.038-9 9-9h23v-1.885c0-10.065 2.3-19.602 6.402-28.115h-29.402c-21.505 0-39 17.495-39 39v23.615h30z"/>
      <path
        d="m477 122.617h-240c-19.299 0-35 15.701-35 35v289.385c0 17.601 13.061 32.203 30 34.637v15.359c0 8.284 6.716 15 15 15s15-6.716 15-15v-14.997h190v14.997c0 8.284 6.716 15 15 15s15-6.716 15-15v-15.359c16.938-2.434 30-17.036 30-34.637v-289.385c0-19.3-15.701-35-35-35zm-185 304.385c0 8.284-6.716 15-15 15s-15-6.716-15-15v-249.385c0-8.284 6.716-15 15-15s15 6.716 15 15zm145 15c-8.284 0-15-6.716-15-15v-249.385c0-8.284 6.716-15 15-15s15 6.716 15 15v249.385c0 8.284-6.716 15-15 15z"/>
    </svg>
  )
}


export default ({ name, color = '', style = '', }: IProps) => {
  switch (name) {
    case 'Admin':
      return Admin(color);
    case 'Person':
      return Person(color);
    case 'People':
      return People(color);
    case 'Edit':
      return Edit(color);
    case 'Editing':
      return Editing(color);
    case 'Globe':
      return Globe(color);
    case 'ShieldTicked':
      return ShieldTicked(color);
    case 'Tick':
      return Tick(color);
    case 'ShieldPlus':
      return ShieldPlus(color);
    case 'winter_sports':
      return WinterSports(color);
    case 'excess_waiver':
      return Excess(color);
    case 'golf_cover':
      return GolfCover(color);
    case 'gadget_cover':
      return GadgetCover(color);
    case 'cruise_cover':
      return CruiseCover(color);
    case 'Calendar':
      return Calendar(color);
    case 'IPID':
      return IPID(color);
    case 'Date':
      return DATE(color);
    case 'Money':
      return MONEY(color);
    case 'Warning':
      return WARNING(color);
    case 'Payment':
      return PAYMENT(color);
    case 'Lock':
      return LOCK(color);
    case 'Summary':
      return SUMMARY(color);
    case 'ImportantStatement':
      return IMPORTANTSTATEMENT(color);
    case 'AnnualCalendar':
      return AnnualCalendar(color, style);
    case 'Tickets':
      return PlaneTickets(color);
    case 'TravelInsurance':
      return Insurance(color);
    case 'Destination':
      return Destination(color);
    case 'Luggage':
      return Luggage(color, style);
    default:
      console.error('No name provided');
  }
};
